import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { UserProvider } from "./data/users/UserContext";
import { Provider } from "react-redux";
import { store } from "./storage/Store";
import "bootstrap/dist/css/bootstrap.min.css";
import { DashboardProvider } from "./data/dashboard/DashboardContext";
import { DataProvider } from "./data/general/DataContext";
import { TableProvider } from "./data/TableContext";
import { ServiceProvider } from "./data/services/ServiceContext";
import { PersonelProvider } from "./data/personel/PersonelContext";
import { CustomerProvider } from "./data/customer/CustomerContext";
import { CashProvider } from "./data/cash/CashContext";
import { WarehouseProvider } from "./data/warehouse/WarehouseContext";
import { OfferProvider } from "./data/offer/OfferContext";
import { TextFormatProvider } from "./data/TextFormatContext";
import { ActionProvider } from "./data/action/ActionContext";
import { SubActionProvider } from "./data/action/SubActionContext"; // ✅ ekledik
import { PersonProvider } from "./data/personel/PersonContext";
import { ValidationProvider } from "./data/ValidationContext";
import { BrandsProvider } from "./data/brands/BrandsContext";
import { DevicesProvider } from "./data/devices/DevicesContext";
import { VehiclesProvider } from "./data/vehicles/VehiclesContext";
import { SuppliersProvider } from "./data/suppliers/SuppliersContext";
import { DealersProvider } from "./data/dealers/DealersContex";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <TextFormatProvider>
        <ValidationProvider>
        <DataProvider>
          <TableProvider>
            <DashboardProvider>
              <DealersProvider>
              <SuppliersProvider>
              <VehiclesProvider>
              <BrandsProvider>
              <DevicesProvider>
              <UserProvider>
                <PersonProvider>
                <ActionProvider>
                  <SubActionProvider> 
                    <CustomerProvider>
                      <ServiceProvider>
                        <PersonelProvider>
                          <WarehouseProvider>
                            <OfferProvider>
                              <CashProvider>
                                <App />
                              </CashProvider>
                            </OfferProvider>
                          </WarehouseProvider>
                        </PersonelProvider>
                      </ServiceProvider>
                    </CustomerProvider>
                  </SubActionProvider>
                </ActionProvider>
                </PersonProvider>
              </UserProvider>
               </DevicesProvider>
              </BrandsProvider>
              </VehiclesProvider>
              </SuppliersProvider>
              </DealersProvider>
            </DashboardProvider>
          </TableProvider>
        </DataProvider>
        </ValidationProvider>
      </TextFormatProvider>
    </Provider>
  </React.StrictMode>
);
